module.exports = __webpack_public_path__ + "static/media/gamesPlayed_50_100.06ae2732.png";